app.service('finalizeView', function (ePaymentModal, ePaymentBlikModal, orderConfig, loading, localStorage, modal, console, kredytLineRedirect, productInteractionListener) {
	var config,
		toEPaymentTimeCount,
		toKredytLineTimeCount,
		timeoutId;

	function setEvents () {
		$('body').on('click', '.js-invoice-download', function () {
			const code = encodeURI( $(this).data('code') );

			getMessage(code)
				.then(showMessage)
				.catch(onError);
		});

		$('body').on('click', '.js-kredytline-redirect', function () {
			kredytLineRedirect.redirect({
				orderNumber: $(this).data('order')
			}, {
				timeout: config.nklTimeout,
				revisions: config.nklRevisions
			});
		});

		$('#manual-payment-btn').click(function(){
			modal.close('EPayment');

			ePaymentModalLoad();
		});

		$('#manual-payment-operator-blik-btn').on('click', function(){
			modal.open('EPayment-operator-blik');
		});

		$('#manual-payment-blik-btn').on('click', function(){
			if (config.ePaymentType == 'PaymentModule') {
				ePaymentModalLoad();
			} else {
				ePaymentBlikModal.load(config.ePaymentType, config.orderNumber);
			}
		});

		$(document).on('closing', '#modal-EPayment, #modal-kredytLine-count', function () {
			stopCountingAutomaticRedirect(); // na zamkniecie modala - przerwac odliczanie!
		});

		$('#js-close-error-modal').click(function() {
			modal.close('modal-EPayment-error');
		});

		$('.js-trade-doubler').on('load', function() {
			tradeDoublerConfirm();
		});
	}

	function tradeDoublerConfirm() {
		$.ajax({
			type: "GET",
			url: '/order-path-trade-doubler-confirm.ltr',
			data:{
				orderNumber:config.orderNumber
			}
		});
	}

	function stopCountingAutomaticRedirect(){
		clearTimeout(timeoutId);
	}

	function onError (e) {
		console.error(`[Błąd pobierania komunikatu] ${e.status} (${e.statusText})`);
	}

	function showMessage (content) {
		const id = 'modal-message';
		modal.generate({ id, content });
	}

	function getMessage (linkName) {
		return $.ajax({
			url:`/cmsPageFancy.ltr`,
			data: { linkName }
		});
	}

	function gotoKredytLine(){
		ePaymentModal.goToInstalment(config.orderNumber, config.instalmentNumber);
	}

	function ePaymentModalLoad () {
		ePaymentModal.load({
			type:config.ePaymentType,
			orderNumber: config.orderNumber
		});
	}

	function showEPaymentMessage () {
		modal.open('EPayment', { modifier: config.rwd ? 'remodal-full-width' : ''});

		setEPaymentTimeoutToClose();

		$("#go-to-payment-site").click(function() {
			modal.close('EPayment');
			ePaymentModalLoad();
		});
	}

	function showEPaymentOperatorBlik () {
		modal.open('EPayment-operator-blik');

		$("#operator-blik-payment").click(function() {
			modal.close('EPayment-operator-blik');
			//obsługa płatności BLIK z aplikacji lub przez stronę operatora zależne od parametru systemowego BLIK_CODE_INPUT_ENABLED
			if (config.ePaymentType && config.ePaymentType == 'PaymentModule') {
				loadingStart();
				document.location.href='/order-payment-module.bhtml';
			} else {

				config.isBlikCodeInputEnabled ? ePaymentBlikModal.load(config.ePaymentType, config.orderNumber) : ePaymentModalLoad();
			}
		});
		$("#operator-blik-cancel").click(function() {
			modal.close('EPayment-operator-blik');
		});
	}

	function setEPaymentTimeoutToClose () {
		toEPaymentTimeCount--; console.log("odliczam" + toEPaymentTimeCount);
		var text='Płacę';
		if (toEPaymentTimeCount===0) {
			modal.close('EPayment');
			ePaymentModalLoad();
			$('#modal-EPayment a').text(text);
		} else {
			$('#modal-EPayment a').text(text + ' ('+toEPaymentTimeCount+')');
			timeoutId = setTimeout(function(){
				setEPaymentTimeoutToClose();
			}, 1000);
		}
	}

	function setKredytLineTimeoutToClose(){
		toKredytLineTimeCount--;
		if(toKredytLineTimeCount===0){
			gotoKredytLine();
		}
		else{
			timeoutId = setTimeout(function(){
				setKredytLineTimeoutToClose();
			},1000);
		}
	}

	function showKredytLineMessage(){
		modal.open('kredytLine-count');
		setKredytLineTimeoutToClose();
	}

	function showMessageIfNeeded () {
		if (config.showCardSubscriptionEncouragement) {
			showCardSubscriptionEncouragement();
		} else if ((config.ePaymentType && config.toEPaymentTimeCount) || (config.ePaymentType && config.ePaymentType === 'PaymentModule')) {
			if (config.isOperatorMode === true) {
				showEPaymentOperatorBlik();
			} else if (config.ePaymentBlik === true) {
				ePaymentBlikModal.load(config.ePaymentType, config.orderNumber);
			} else {
				showEPaymentMessage();
			}
		} else if (config.kredytLine && config.kredytLineTimeCount) {
			showKredytLineMessage();
		}
	}

	function setConfig () {
		config = orderConfig.getData();

		toEPaymentTimeCount = config.toEPaymentTimeCount;

		if (config.kredytLineTimeCount) {
			toKredytLineTimeCount = config.kredytLineTimeCount;
		}
	}

	function operatorClearShops() {
		localStorage.removeItem('rememberShops');
	}

	function showCardSubscriptionEncouragement() {
		$.ajax({
			type: "GET",
			url: '/order-path-card-subscription-encouragement.ltr',
			success: function(html){
				modal.generate({
					id: 'card-subscription-encouragement',
					close:true,
					content: html,
				});
				$('#js-encouragement-description-toggler').click(function() {
					$('#js-encouragement-description').toggleClass('is-full');
					if ($('#js-encouragement-description').hasClass('is-full')) {
						UA.interaction('PG', 'Abonament','Co warto wiedziec')
					}
				});
				$('#card-subscription-encouragement .remodal-close').click(function() {
					UA.interaction('PG', 'Abonament','Zrob to pozniej');
				})
				$('.js-subscribe-card').click(function subscribeCard() {
					UA.interaction('PG', 'Abonament','Dodaj karte')
					loading.start();
					$.ajax({
						method: 'POST',
						url: '/card-subscription-transaction-payment-url.ltr',
						data: {
							orderNumber: config.orderNumber
						}
					}).then(response => {
						if (response.status === 'FAIL') {
							loading.stop();
							modal.alert(response.messages.join(''));
						} else {
							loading.redirect(response.transactionPaymentUrl);
						}
					}).fail(() => {
						loading.stop();
						modal.alert("Wystąpiły problemy techniczne. Spróbuj dodać kartę w koncie klienta lub skontaktuj się z działem pomocy.");
					});
				});
			},
			error:function(){
				modal.alert('Wystąpiły problemy techniczne. Spróbuj dodać kartę w koncie klienta lub skontaktuj się z działem pomocy.');
			}
		});
	}

	function init () {
		setConfig();
		setEvents();
		ePaymentBlikModal.init();
		productInteractionListener.onOrderFinalizeView(config.orderedProductIds)
		if (config.showPopupAfterBuyingMessage) {
			modal.open('after-buying-message');
			$(document).on('closed', '#modal-after-buying-message', function() {
				showMessageIfNeeded();
			});
		} else {
			showMessageIfNeeded();
		}
		operatorClearShops();
	}

	return { init };
});
